/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Partial building
 */
export interface Bridge { 
    /**
     * Internal Structure Key
     */
    id?: number;
    /**
     * Structure Key
     */
    structureId: number;
    structureUpper?: string;
    structureLower?: string;
    /**
     * Contains some properties about a bridge
     */
    numericProperties?: string;
    /**
     * Contains some category information about a bridge
     */
    categories?: string;
    /**
     * Contains extra information about a bridge
     */
    textProperties?: string;
}

